/**
 * 把百度的坐标点序列转换为geojson的工具类
 */
export default {
  /**
   * 转换为多边形，最常用
   * @param {array} points 
   * @returns 
   */
  asPolygon: function (points, properties) {
    return {
      geometry: {
        type: 'Polygon',
        coordinates: [this.asCoordinates(points)]
      },
      properties: properties || {}
    }
  },

  /**
   * 转换为线串
   * @param {array} points 
   * @returns 
   */
  asLineString: function (points) {
    return {
      geometry: {
        type: 'LineString',
        coordinates: this.asCoordinates(points)
      }
    }
  },

  /**
   * 只转换为geojson坐标序列，外部一般不要调用，供内部方法调用
   * @param {array} points 
   * @returns 
   */
  asCoordinates: function (points) {
    const coordinates = []
    if (points != null && points.length > 0) {
      points.forEach(p => {
        coordinates.push([p.lng, p.lat])
      })
    }
    return coordinates
  }
}



// WEBPACK FOOTER //
// ./src/common/Points2Geo.js